import i18n from "i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLangs: ["en", "it", "pt", "es", "fr", "de"],
    backend: {
      loadPath: "/assets/languages/{{lng}}/index.json",
    },
    fallbackLng: "en",
    detection: {
      order: ["localStorage", "cookie", "htmlTag", "path", "subdomain"],
      // caches: ["cookie"],
    },
    // debug:true,
    interpolation: {
      escapeValue: false,
      formatSeperator: ",",
    },
    react: {
      wait: true,
    },
  });

export default i18n;
